import { z } from 'zod';
import { emailFieldSchema } from './fields';

export const signInSchema = (t) =>
  z.object({
    email: emailFieldSchema(t),
    password: z.string().min(3, { message: t('error.passwordTooShort') }),
  });
